import { PILLAR, WELL, HOUSE } from "../Constants/ConstantsOptics";
import { DELETE_CABLE_COUPLING_CONNECTION_API_URL, DELETE_CABLE_FOB_CONNECTION_API_URL, DELETE_CABLE_PON_BOX_CONNECTION_API_URL,
  DELETE_CABLE_PILLAR_CONNECTION_API_URL, DELETE_CABLE_WELL_CONNECTION_API_URL, DELETE_CABLE_HOUSE_CONNECTION_API_URL,
  DELETE_CABLE_LINE_PERENT_CONNECTION_API_URL, DELETE_START_CABLE_CONNECTION_API_URL, DELETE_END_CABLE_CONNECTION_API_URL,
  DELETE_PILLAR_CABLE_CONNECTION_API_URL, DELETE_PILLAR_COUPLING_CONNECTION_API_URL, DELETE_PILLAR_FOB_CONNECTION_API_URL,
  DELETE_PILLAR_PON_BOX_CONNECTION_API_URL, DELETE_WELL_CABLE_CONNECTION_API_URL, DELETE_WELL_COUPLING_CONNECTION_API_URL,
  DELETE_WELL_FOB_CONNECTION_API_URL, DELETE_COUPLING_HOUSE_CONNECTION_API_URL, DELETE_COUPLING_CABLE_CONNECTION_API_URL,
  DELETE_COUPLING_PILLAR_CONNECTION_API_URL, DELETE_COUPLING_WELL_CONNECTION_API_URL, DELETE_FOB_CABLE_CONNECTION_API_URL,
  DELETE_FOB_HOUSE_CONNECTION_API_URL, DELETE_FOB_PILLAR_CONNECTION_API_URL, DELETE_FOB_WELL_CONNECTION_API_URL,  
  DELETE_PON_BOX_CABLE_CONNECTION_API_URL,  DELETE_PON_BOX_HOUSE_CONNECTION_API_URL,  DELETE_PON_BOX_PILLAR_CONNECTION_API_URL, 
  DELETE_CABLE_CASSETTE_CONNECTION_API_URL} from "../OpticApiConfig";

//========================================CABLE==============================================================
 // Удаления связи CABLE -> COUPLING
export const deleteConnectionCableCoupling = async ( cableId, couplingId, descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      await fetch(`${DELETE_CABLE_COUPLING_CONNECTION_API_URL}?cableId=${cableId}&couplingId=${couplingId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      descriptionComponents();
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

  // Удаления связи CABLE -> FOB
export const deleteConnectionCableFob = async ( cableId, fobId, descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }
     
    try {
      await fetch(`${DELETE_CABLE_FOB_CONNECTION_API_URL}?cableId=${cableId}&fobId=${fobId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      descriptionComponents();
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

   // Удаления связи CABLE -> PON-BOX
export const deleteConnectionCablePonBox = async ( cableId, ponBoxId, descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
     await fetch(`${DELETE_CABLE_PON_BOX_CONNECTION_API_URL}?cableId=${cableId}&ponBoxId=${ponBoxId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      descriptionComponents();
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

  // Удаления связи CABLE -> PILLAR
export const deleteConnectionCablePillar = async ( cableId, pillarId,  descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      await fetch(`${DELETE_CABLE_PILLAR_CONNECTION_API_URL}?cableId=${cableId}&pillarId=${pillarId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      descriptionComponents();
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

   // Удаления связи CABLE -> WELL
export const deleteConnectionCableWell = async ( cableId, wellId,  descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
     await fetch(`${DELETE_CABLE_WELL_CONNECTION_API_URL}?cableId=${cableId}&wellId=${wellId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      descriptionComponents();
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

  // Удаления связи CABLE -> CASSETTE
export const deleteConnectionCableCassette = async ( cableId, cassetteId,  descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
     await fetch(`${DELETE_CABLE_CASSETTE_CONNECTION_API_URL}?cableId=${cableId}&cassetteId=${cassetteId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      descriptionComponents();
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

  // Удаления связи CABLE -> HOUSE
export const deleteConnectionCableHouse = async ( cableId, houseId, entrance,  descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
     await fetch(`${DELETE_CABLE_HOUSE_CONNECTION_API_URL}?cableId=${cableId}&houseId=${houseId}&entrance=${entrance}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      descriptionComponents();
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };


   // Удаления связи CABLE -> LINE_PERENT
export const deleteConnectionCableLineParent = async ( cableId, lineParentId,  descriptionComponents) => {

  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      await fetch(`${DELETE_CABLE_LINE_PERENT_CONNECTION_API_URL}?cableId=${cableId}&lineParentId=${lineParentId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
      descriptionComponents();
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };


   // Удаления связи START CABLE
export const deleteConnectionStartCable = async ( cableId, conponentId, type, descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      if(type === WELL){
        const model = {
          HighwayLineId: cableId,
          WellId: conponentId,
          Type: type
        };

            await fetch(`${DELETE_START_CABLE_CONNECTION_API_URL}`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' 
              },
              body: JSON.stringify(model) 
            });
            descriptionComponents();

       } else if(type === PILLAR){
           const model = {
             HighwayLineId: cableId,
             PillarId: conponentId,
             Type: type
            };

            await fetch(`${DELETE_START_CABLE_CONNECTION_API_URL}`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' 
              },
              body: JSON.stringify(model) 
            });
            descriptionComponents();
           

       } else if(type === HOUSE){
        const model = {
          HighwayLineId: cableId,
          HouseId: conponentId,
          Type: type
         };

         await fetch(`${DELETE_START_CABLE_CONNECTION_API_URL}`, {
           method: 'DELETE',
           headers: {
             'Authorization': `Bearer ${token}`,
             'Content-Type': 'application/json' 
           },
           body: JSON.stringify(model) 
         });
         descriptionComponents();    

    }else {
      console.log("error type");
    }
    
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

  // Удаления связи END CABLE
export const deleteConnectionEndCable = async ( cableId, conponentId, type, descriptionComponents) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      if(type === WELL){
        const model = {
          HighwayLineId: cableId,
          WellId: conponentId,
          Type: type
        };

            await fetch(`${DELETE_END_CABLE_CONNECTION_API_URL}`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' 
              },
              body: JSON.stringify(model) 
            });
            descriptionComponents();

       } else if(type === PILLAR){
           const model = {
             HighwayLineId: cableId,
             PillarId: conponentId,
             Type: type
            };

            await fetch(`${DELETE_END_CABLE_CONNECTION_API_URL}`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' 
              },
              body: JSON.stringify(model) 
            });
            descriptionComponents();
           

       } else if(type === HOUSE){
        const model = {
          HighwayLineId: cableId,
          HouseId: conponentId,
          Type: type
         };

         await fetch(`${DELETE_END_CABLE_CONNECTION_API_URL}`, {
           method: 'DELETE',
           headers: {
             'Authorization': `Bearer ${token}`,
             'Content-Type': 'application/json' 
           },
           body: JSON.stringify(model) 
         });
         descriptionComponents();    

    }else {
      console.log("error type");
    }
    
    } catch (error) {
      //setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };

  //========================================PILLAR==============================================================
  // Удаления связи PILLAR -> COUPLING
  export const deleteConnectionPillarCoupling = async ( pillarId, couplingId, descriptionComponents) => {
  
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_PILLAR_COUPLING_CONNECTION_API_URL}?pillarId=${pillarId}&couplingId=${couplingId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи PILLAR -> FOB
  export const deleteConnectionPillarFob = async ( pillarId, fobId, descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
       
      try {
        await fetch(`${DELETE_PILLAR_FOB_CONNECTION_API_URL}?pillarId=${pillarId}&fobId=${fobId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
     // Удаления связи PILLAR -> PON-BOX
  export const deleteConnectionPillarPonBox = async ( pillarId, ponBoxId, descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
       await fetch(`${DELETE_PILLAR_PON_BOX_CONNECTION_API_URL}?pillarId=${pillarId}&ponBoxId=${ponBoxId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи PILLAR -> CABLE
  export const deleteConnectionPillarCable = async ( pillarId, cableId,  descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_PILLAR_CABLE_CONNECTION_API_URL}?pillarId=${pillarId}&cableId=${cableId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };


     //========================================WELL==============================================================
  // Удаления связи WELL -> COUPLING
  export const deleteConnectionWellCoupling = async ( wellId, couplingId, descriptionComponents) => {
  
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_WELL_COUPLING_CONNECTION_API_URL}?wellId=${wellId}&couplingId=${couplingId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи WELL -> FOB
  export const deleteConnectionWellFob = async ( wellId, fobId, descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
       
      try {
        await fetch(`${DELETE_WELL_FOB_CONNECTION_API_URL}?wellId=${wellId}&fobId=${fobId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи WELL -> CABLE
  export const deleteConnectionWellCable = async ( wellId, cableId,  descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_WELL_CABLE_CONNECTION_API_URL}?wellId=${wellId}&cableId=${cableId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };

 //========================================COUPLING==============================================================
  // Удаления связи COUPLING -> HOUSE
  export const deleteConnectionCouplingHouse = async ( couplingId, houseId, descriptionComponents) => {
  
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_COUPLING_HOUSE_CONNECTION_API_URL}?couplingId=${couplingId}&houseId=${houseId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи COUPLING -> WELL
  export const deleteConnectionCouplingWell = async ( couplingId, wellId, descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
       
      try {
        await fetch(`${DELETE_COUPLING_WELL_CONNECTION_API_URL}?couplingId=${couplingId}&wellId=${wellId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
     // Удаления связи COUPLING -> PILLAR
  export const deleteConnectionCouplingPillar = async ( couplingId, pillarId, descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
       await fetch(`${DELETE_COUPLING_PILLAR_CONNECTION_API_URL}?couplingId=${couplingId}&pillarId=${pillarId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи COUPLING -> CABLE
  export const deleteConnectionCouplingCable = async ( couplingId, cableId,  descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_COUPLING_CABLE_CONNECTION_API_URL}?couplingId=${couplingId}&cableId=${cableId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };

 //========================================FOB==============================================================
  // Удаления связи FOB -> HOUSE
  export const deleteConnectionFobHouse = async ( fobId, houseId, descriptionComponents) => {
  
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_FOB_HOUSE_CONNECTION_API_URL}?fobId=${fobId}&houseId=${houseId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи FOB -> WELL
  export const deleteConnectionFobWell = async ( fobId, wellId, descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
       
      try {
        await fetch(`${DELETE_FOB_WELL_CONNECTION_API_URL}?fobId=${fobId}&wellId=${wellId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
     // Удаления связи FOB -> PILLAR
  export const deleteConnectionFobPillar = async ( fobId, pillarId, descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
       await fetch(`${DELETE_FOB_PILLAR_CONNECTION_API_URL}?fobId=${fobId}&pillarId=${pillarId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи FOB -> CABLE
  export const deleteConnectionFobCable = async ( fobId, cableId,  descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_FOB_CABLE_CONNECTION_API_URL}?fobId=${fobId}&cableId=${cableId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
   
    //========================================PON-BOX==============================================================
  // Удаления связи PON-BOX -> HOUSE
  export const deleteConnectionPonBoxHouse = async ( ponBoxId, houseId, descriptionComponents) => {
  
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_PON_BOX_HOUSE_CONNECTION_API_URL}?ponBoxId=${ponBoxId}&houseId=${houseId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
     // Удаления связи PON-BOX -> PILLAR
  export const deleteConnectionPonBoxPillar = async ( ponBoxId, pillarId, descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
       await fetch(`${DELETE_PON_BOX_PILLAR_CONNECTION_API_URL}?ponBoxId=${ponBoxId}&pillarId=${pillarId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
  
    // Удаления связи PON-BOX -> CABLE
  export const deleteConnectionPonBoxCable = async ( ponBoxId, cableId,  descriptionComponents) => {
    
    const token = localStorage.getItem('token');
        if (!token) {
            console.log('Ошибка! Токен не найден');
            return;
        }
  
      try {
        await fetch(`${DELETE_PON_BOX_CABLE_CONNECTION_API_URL}?ponBoxId=${ponBoxId}&cableId=${cableId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}` 
          }
        });
        descriptionComponents();
      } catch (error) {
        //setUploadMessage('Ошибка удаления файла: ' + error.message);
      }
    };
   

